// src/redux/contextRadar/contextRadarActionThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import contextRadarAPI from "./contextRadarAPI";

// Fetch per-ticker events
export const fetchContextRadarForTicker = createAsyncThunk(
  "contextRadar/fetchForTicker",
  async ({ ticker, limit = 20 }, { rejectWithValue }) => {
    try {
      const data = await contextRadarAPI.getTickerEvents(ticker, limit);
      return { ticker, data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to load context radar ticker events");
    }
  }
);

// Fetch watchlist events for many tickers
export const fetchContextRadarForWatchlist = createAsyncThunk(
  "contextRadar/fetchForWatchlist",
  async ({ tickers, limitPerTicker = 5 }, { rejectWithValue }) => {
    try {
      const data = await contextRadarAPI.getWatchlistEvents(tickers, limitPerTicker);
      return { tickers, data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to load context radar watchlist events");
    }
  }
);

// Fetch global events
export const fetchGlobalContextRadar = createAsyncThunk(
  "contextRadar/fetchGlobal",
  async ({ limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const data = await contextRadarAPI.getGlobalEvents(limit);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to load global context radar events");
    }
  }
);
